
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"calendar-edit (1)","d":"M15.285 1.8h-.955V0h-1.911v1.8H4.776V0h-1.91v1.8h-.955A1.858 1.858 0 000 3.6v12.6A1.858 1.858 0 001.911 18h4.776v-1.8H1.911V6.3h13.374v.9H17.2V3.6a1.858 1.858 0 00-1.911-1.8m2.579 9.315l-.955.9-1.958-1.8.955-.9a.538.538 0 01.736 0l1.223 1.152a.454.454 0 010 .648M8.6 16.146l5.8-5.454 1.958 1.8L10.565 18H8.6z"}})])
          )
        }
      }
    